import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faUserPlus,
    faEdit,
    faSave,
    faTimes,
    faCheckCircle,
    faExclamationTriangle,
    faBuilding,
    faPhone,
    faMapMarkerAlt,
    faBriefcase,
    faCalendarAlt,
    faMoneyBillWave,
    faDollarSign,
    faClock,
    faTasks,
    faIdCard,
    faUserTag,
    faWallet,
    faCreditCard,
    faIdCard as faCnic,
    faFileAlt,
    faSpinner,
    faChevronDown,
    faStore,
    faExchangeAlt,
    faStickyNote
} from '@fortawesome/free-solid-svg-icons';
// import "./Styles/Form.css";

// Create translator instance
const createEmployeeTranslator = () => {
    const urduTranslations = {
        addEmployee: 'ملازم شامل کریں',
        editEmployee: 'ملازم میں ترمیم کریں',
        fillDetails: 'براہ کرم ملازم کی تفصیلات درج کریں',
        employeeName: 'ملازم کا نام',
        employeeCode: 'ملازم کوڈ',
        cnicNumber: 'شناختی کارڈ نمبر',
        phone: 'فون نمبر',
        address: 'پتہ',
        position: 'عہدہ',
        hireDate: 'تاریخ شمولیت',
        salaryType: 'تنخواہ کی قسم',
        fixedSalary: 'مقررہ تنخواہ',
        dailyWage: 'یومیہ اجرت',
        taskBased: 'ٹاسک کی بنیاد پر',
        fixedSalaryAmount: 'مقررہ تنخواہ کی رقم',
        dailyWageRate: 'یومیہ اجرت کی شرح',
        taskRate: 'ٹاسک ریٹ',
        status: 'حالت',
        active: 'فعال',
        inactive: 'غیر فعال',
        terminated: 'برطرف',
        save: 'محفوظ کریں',
        update: 'اپ ڈیٹ کریں',
        clear: 'صاف کریں',
        cancel: 'منسوخ کریں',
        employeeSaved: 'ملازم کامیابی سے محفوظ ہو گیا!',
        employeeUpdated: 'ملازم کامیابی سے اپ ڈیٹ ہو گیا!',
        failedAdd: 'ملازم محفوظ کرنے میں ناکامی',
        failedUpdate: 'ملازم اپ ڈیٹ کرنے میں ناکامی',
        networkError: 'نیٹ ورک کی خرابی',
        nameRequired: 'ملازم کا نام ضروری ہے',
        phoneInvalid: 'درست فون نمبر درج کریں',
        salaryRequired: 'تنخواہ کی رقم ضروری ہے',
        success: 'کامیابی',
        error: 'خرابی',
        warning: 'انتباہ',
        selectShop: 'پہلے دکان منتخب کریں',
        noShopSelected: 'کوئی دکان منتخب نہیں',
        switchShop: 'دکان تبدیل کریں',
        addPayment: 'ادائیگی شامل کریں',
        paymentAmount: 'ادائیگی کی رقم',
        paymentDate: 'ادائیگی کی تاریخ',
        paymentType: 'ادائیگی کی قسم',
        paymentMethod: 'ادائیگی کا طریقہ',
        cash: 'نقد',
        bankTransfer: 'بینک ٹرانسفر',
        cheque: 'چیک',
        description: 'وضاحت',
        selectSalaryType: 'تنخواہ کی قسم منتخب کریں',
        draftLoaded: 'ڈرافٹ لوڈ ہو گیا',
        draftCleared: 'ڈرافٹ صاف کر دیا گیا',
        draftExists: 'پہلے سے محفوظ ڈرافٹ موجود ہے',
        saveDraft: 'ڈرافٹ محفوظ کریں',
        drafts: 'ڈرافٹس',
        savedDrafts: 'محفوظ کردہ ڈرافٹس',
        unnamedEmployee: 'نامعلوم ملازم',
        noDraftsSaved: 'کوئی ڈرافٹ محفوظ نہیں',
        clearForm: 'فارم صاف کریں',
        viewDrafts: 'ڈرافٹس دیکھیں'
    };

    const defaultTexts = {
        addEmployee: 'Add Employee',
        editEmployee: 'Edit Employee',
        fillDetails: 'Fill in the employee details below',
        employeeName: 'Employee Name',
        employeeCode: 'Employee Code',
        cnicNumber: 'CNIC Number',
        phone: 'Phone Number',
        address: 'Address',
        position: 'Position',
        hireDate: 'Hire Date',
        salaryType: 'Salary Type',
        fixedSalary: 'Fixed Salary',
        dailyWage: 'Daily Wages',
        taskBased: 'Task Based',
        fixedSalaryAmount: 'Fixed Salary Amount',
        dailyWageRate: 'Daily Wage Rate',
        taskRate: 'Task Rate',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        terminated: 'Terminated',
        save: 'Save',
        update: 'Update',
        clear: 'Clear',
        cancel: 'Cancel',
        employeeSaved: 'Employee saved successfully!',
        employeeUpdated: 'Employee updated successfully!',
        failedAdd: 'Failed to save employee',
        failedUpdate: 'Failed to update employee',
        networkError: 'Network error occurred',
        nameRequired: 'Employee name is required',
        phoneInvalid: 'Please enter a valid phone number',
        salaryRequired: 'Salary amount is required',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        selectShop: 'Select a shop first',
        noShopSelected: 'No shop selected',
        switchShop: 'Switch Shop',
        addPayment: 'Add Payment',
        paymentAmount: 'Payment Amount',
        paymentDate: 'Payment Date',
        paymentType: 'Payment Type',
        paymentMethod: 'Payment Method',
        cash: 'Cash',
        bankTransfer: 'Bank Transfer',
        cheque: 'Cheque',
        description: 'Description',
        selectSalaryType: 'Select salary type',
        draftLoaded: 'Draft loaded',
        draftCleared: 'Draft cleared',
        draftExists: 'A saved draft exists',
        saveDraft: 'Save Draft',
        drafts: 'Drafts',
        savedDrafts: 'Saved Drafts',
        unnamedEmployee: 'Unnamed Employee',
        noDraftsSaved: 'No drafts saved',
        clearForm: 'Clear Form',
        viewDrafts: 'View Drafts'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') return defaultTexts;
        if (lang === 'ur') return urduTranslations;
        return defaultTexts;
    };

    return { getTranslations };
};

const employeeTranslator = createEmployeeTranslator();

// Request deduplication helper
const requestTracker = new Map();

function isDuplicateRequest(requestData) {
    const key = JSON.stringify({
        action: requestData.action,
        employee_name: requestData.employee_name,
        phone: requestData.phone,
        shop_id: requestData.shop_id
    });

    const now = Date.now();
    const lastRequest = requestTracker.get(key);

    if (lastRequest && (now - lastRequest) < 5000) {
        return true;
    }

    requestTracker.set(key, now);

    for (const [k, time] of requestTracker.entries()) {
        if (now - time > 10000) {
            requestTracker.delete(k);
        }
    }

    return false;
}

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};


// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozui_modal-overlay" onClick={onClose}>
            <div className="ozui_modal" onClick={e => e.stopPropagation()}>
                <div className="ozui_modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozui_modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozui_modal-body">
                    {loading ? (
                        <div className="ozui_loading-state">{translations.loadingShops || 'Loading shops...'}</div>
                    ) : shops.length === 0 ? (
                        <div className="ozui_empty-state">{translations.noShops || 'No shops available'}</div>
                    ) : (
                        shops.map((shop) => (
                            <div 
                                key={shop.shop_id}
                                className={`ozui_shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozui_active' : ''}`}
                                onClick={() => onSelectShop(shop)}
                            >
                                <div className="ozui_shop-info">
                                    <div className="ozui_shop-name">{shop.shop_name}</div>
                                    <div className="ozui_shop-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                </div>
                                {currentShop?.shop_id === shop.shop_id && (
                                    <div className="ozui_shop-badge">✓ {translations.current || 'Current'}</div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

// Payment Modal Component
const PaymentModal = ({ isOpen, onClose, onSubmit, translations, loading, paymentData, setPaymentData }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPaymentData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="ozui_modal-overlay" onClick={onClose}>
            <div className="ozui_modal" onClick={e => e.stopPropagation()}>
                <div className="ozui_modal-header">
                    <h3>{translations.addPayment || 'Add Payment'}</h3>
                    <button className="ozui_modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozui_modal-body">
                    <div className="ozui-form-row">
                        <div className="ozui-field">
                            <div className="ozui-input-wrapper">
                                <input
                                    type="number"
                                    name="amount"
                                    value={paymentData.amount}
                                    onChange={handleChange}
                                    step="0.01"
                                    min="0"
                                    placeholder=" "
                                />
                                <label>
                                    <FontAwesomeIcon icon={faDollarSign} />
                                    {translations.paymentAmount || 'Payment Amount'} <span>*</span>
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field">
                            <div className="ozui-input-wrapper">
                                <input
                                    type="date"
                                    name="payment_date"
                                    value={paymentData.payment_date}
                                    onChange={handleChange}
                                    placeholder=" "
                                />
                                <label>
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                    {translations.paymentDate || 'Payment Date'}
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field">
                            <div className="ozui-input-wrapper">
                                <select name="payment_type" value={paymentData.payment_type} onChange={handleChange}>
                                    <option value="salary">Salary</option>
                                    <option value="advance">Advance</option>
                                    <option value="bonus">Bonus</option>
                                    <option value="deduction">Deduction</option>
                                </select>
                                <label>
                                    <FontAwesomeIcon icon={faWallet} />
                                    {translations.paymentType || 'Payment Type'}
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field">
                            <div className="ozui-input-wrapper">
                                <select name="payment_method" value={paymentData.payment_method} onChange={handleChange}>
                                    <option value="cash">{translations.cash || 'Cash'}</option>
                                    <option value="bank_transfer">{translations.bankTransfer || 'Bank Transfer'}</option>
                                    <option value="cheque">{translations.cheque || 'Cheque'}</option>
                                </select>
                                <label>
                                    <FontAwesomeIcon icon={faCreditCard} />
                                    {translations.paymentMethod || 'Payment Method'}
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field full-width">
                            <div className="ozui-input-wrapper">
                                <textarea
                                    name="description"
                                    value={paymentData.description}
                                    onChange={handleChange}
                                    rows="3"
                                    placeholder=" "
                                />
                                <label>
                                    <FontAwesomeIcon icon={faStickyNote} />
                                    {translations.description || 'Description'}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ozui-form-actions">
                    <button type="button" className="ozui-btn ozui-btn-secondary" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                        <span>{translations.cancel || 'Cancel'}</span>
                    </button>
                    <button type="button" className="ozui-btn ozui-btn-primary" onClick={onSubmit} disabled={loading}>
                        {loading ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                <span>Adding...</span>
                            </>
                        ) : (
                            <>
                                <span>{translations.addPayment || 'Add Payment'}</span>
                                <FontAwesomeIcon icon={faSave} />
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

const PharmacyAddEmployee = ({ employeeId = null, onSuccess = null }) => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();

    // Add ref for employee name input
    const employeeNameInputRef = useRef(null);

    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return user?.language || localStorage.getItem('ourzest_language') || 'en';
    });

    // Salary type options
    const salaryTypeOptions = [
        { value: 'fixed', label: 'fixedSalary' },
        { value: 'daily', label: 'dailyWage' },
        { value: 'task_based', label: 'taskBased' }
    ];

    // Status options
    const statusOptions = [
        { value: 'active', label: 'active' },
        { value: 'inactive', label: 'inactive' },
        { value: 'terminated', label: 'terminated' }
    ];

    // Initial form data
    const initialFormData = {
        employee_name: '',
        employee_code: '',
        cnic_number: '',
        phone: '',
        address: '',
        position: '',
        hire_date: new Date().toISOString().split('T')[0],
        salary_type: 'fixed',
        fixed_salary: '',
        daily_wage_rate: '',
        task_rate: '',
        status: 'active',
        profile_image: '',
        themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
    };

    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [translations, setTranslations] = useState({});
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [currentThemeColor, setCurrentThemeColor] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentData, setPaymentData] = useState({
        amount: '',
        payment_date: new Date().toISOString().split('T')[0],
        payment_type: 'salary',
        payment_method: 'cash',
        description: ''
    });
    const [paymentLoading, setPaymentLoading] = useState(false);

    // Manual dropdown states
    const [showSalaryTypeDropdown, setShowSalaryTypeDropdown] = useState(false);
    const [salaryTypeSearchTerm, setSalaryTypeSearchTerm] = useState('');
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const [statusSearchTerm, setStatusSearchTerm] = useState('');

    // Refs for dropdowns
    const salaryTypeDropdownRef = useRef(null);
    const statusDropdownRef = useRef(null);

    // Refs for preventing duplicate submissions
    const isSubmittingRef = useRef(false);
    const toastTimerRef = useRef(null);
    const lastSubmitTimeRef = useRef(0);
    const lastEmployeeDataRef = useRef('');
    const isInitialLoadRef = useRef(true);
    const isClearingRef = useRef(false);
    const draftsDropdownRef = useRef(null);
    const lastDraftContentRef = useRef('');
    const isAutoSavingRef = useRef(false);

    // Auto-focus on employee name input when form is opened
    useEffect(() => {
        // Focus on the employee name input
        if (employeeNameInputRef.current) {
            employeeNameInputRef.current.focus();
        }
    }, []);

    // Tab key handlers for dropdowns
    const handleSalaryTypeKeyDown = (e) => {
        if (e.key === 'Tab') {
            setShowSalaryTypeDropdown(false);
            // Let the tab naturally move to next element
            return;
        }
    };

    const handleStatusKeyDown = (e) => {
        if (e.key === 'Tab') {
            setShowStatusDropdown(false);
            return;
        }
    };

    // Filtered options for dropdowns
    const filteredSalaryTypes = salaryTypeSearchTerm.trim() === ''
        ? salaryTypeOptions
        : salaryTypeOptions.filter(st =>
            (translations[st.label] || st.label).toLowerCase().includes(salaryTypeSearchTerm.toLowerCase())
          );

    const filteredStatuses = statusSearchTerm.trim() === ''
        ? statusOptions
        : statusOptions.filter(st =>
            (translations[st.label] || st.label).toLowerCase().includes(statusSearchTerm.toLowerCase())
          );

    // Click outside handlers for dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (salaryTypeDropdownRef.current && !salaryTypeDropdownRef.current.contains(event.target)) {
                setShowSalaryTypeDropdown(false);
            }
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setShowStatusDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Draft Management Functions
    const getDraftStorageKey = () => {
        const userId = user?.user_id || user?.username || 'anonymous';
        const shopId = currentShop?.shop_id || 'no_shop';
        return `employee_draft_${userId}_${shopId}`;
    };

    const getCurrentFormContent = () => {
        return JSON.stringify({
            employee_name: formData.employee_name || '',
            employee_code: formData.employee_code || '',
            cnic_number: formData.cnic_number || '',
            phone: formData.phone || '',
            position: formData.position || '',
            salary_type: formData.salary_type || '',
            fixed_salary: formData.fixed_salary || '',
            daily_wage_rate: formData.daily_wage_rate || '',
            task_rate: formData.task_rate || '',
            status: formData.status || ''
        });
    };

    const saveDraft = () => {
        if (isEditMode || isClearingRef.current) {
            if (isEditMode) showToast('warning', 'Cannot save draft in edit mode');
            return false;
        }

        const hasData = formData.employee_name?.trim() ||
            formData.employee_code?.trim() ||
            formData.phone?.trim() ||
            formData.position?.trim();

        if (!hasData) {
            showToast('warning', 'Cannot save empty draft. Please enter at least one field.');
            return false;
        }

        const currentContent = getCurrentFormContent();
        if (currentContent === lastDraftContentRef.current) {
            showToast('info', 'No changes to save');
            return false;
        }

        lastDraftContentRef.current = currentContent;

        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...formData,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };

        const existingDrafts = JSON.parse(localStorage.getItem('employee_drafts') || '[]');
        const filteredDrafts = existingDrafts.filter(d =>
            !(d.employee_name === formData.employee_name &&
              d.phone === formData.phone &&
              d.shop_id === currentShop?.shop_id)
        );

        filteredDrafts.unshift(draft);
        const limitedDrafts = filteredDrafts.slice(0, 20);
        localStorage.setItem('employee_drafts', JSON.stringify(limitedDrafts));

        loadDrafts();
        showToast('success', 'Draft saved successfully!');
        return true;
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem('employee_drafts') || '[]');
        const filteredDrafts = currentShop ? drafts.filter(d => d.shop_id === currentShop?.shop_id) : drafts;
        setSavedDrafts(filteredDrafts);
    };

    const loadDraft = (draft) => {
        setFormData({
            employee_name: draft.employee_name || '',
            employee_code: draft.employee_code || '',
            cnic_number: draft.cnic_number || '',
            phone: draft.phone || '',
            address: draft.address || '',
            position: draft.position || '',
            hire_date: draft.hire_date || new Date().toISOString().split('T')[0],
            salary_type: draft.salary_type || 'fixed',
            fixed_salary: draft.fixed_salary || '',
            daily_wage_rate: draft.daily_wage_rate || '',
            task_rate: draft.task_rate || '',
            status: draft.status || 'active',
            profile_image: draft.profile_image || '',
            themeColor: formData.themeColor
        });

        // Update search terms
        const selectedSalaryType = salaryTypeOptions.find(st => st.value === draft.salary_type);
        setSalaryTypeSearchTerm(selectedSalaryType ? (translations[selectedSalaryType.label] || selectedSalaryType.label) : '');
        const selectedStatus = statusOptions.find(st => st.value === draft.status);
        setStatusSearchTerm(selectedStatus ? (translations[selectedStatus.label] || selectedStatus.label) : '');

        lastDraftContentRef.current = getCurrentFormContent();
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem('employee_drafts') || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem('employee_drafts', JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', 'Draft deleted successfully!');
        if (filteredDrafts.length === 0) lastDraftContentRef.current = '';
    };

    useEffect(() => {
        loadDrafts();
    }, [currentShop]);

    useEffect(() => {
        if (showDraftsList && draftsDropdownRef.current) {
            const button = draftsDropdownRef.current.querySelector('.drafts-btn');
            const dropdown = draftsDropdownRef.current.querySelector('.ozui-drafts-dropdown');
            if (button && dropdown) {
                const rect = button.getBoundingClientRect();
                dropdown.style.position = 'fixed';
                dropdown.style.top = `${rect.bottom + 8}px`;
                dropdown.style.right = `${window.innerWidth - rect.right}px`;
            }
        }
    }, [showDraftsList]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (draftsDropdownRef.current && !draftsDropdownRef.current.contains(event.target)) {
                setShowDraftsList(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const showToast = (type, message) => {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setToast({ show: true, type, message });
        toastTimerRef.current = setTimeout(() => {
            setToast({ show: false, type: '', message: '' });
        }, 3000);
    };

    // Auto-save draft
    useEffect(() => {
        if (isEditMode || isClearingRef.current || isSubmittingRef.current) return;
        if (isInitialLoadRef.current) return;

        const timer = setTimeout(() => {
            if (!isAutoSavingRef.current) {
                isAutoSavingRef.current = true;
                saveDraft();
                isAutoSavingRef.current = false;
            }
        }, 3000);
        return () => clearTimeout(timer);
    }, [
        formData.employee_name,
        formData.employee_code,
        formData.cnic_number,
        formData.phone,
        formData.position,
        formData.salary_type,
        formData.fixed_salary,
        formData.daily_wage_rate,
        formData.task_rate,
        formData.status,
        isEditMode
    ]);

    useEffect(() => {
        if (!isEditMode && !employeeId && currentShop && isInitialLoadRef.current) {
            isInitialLoadRef.current = false;
            const savedDraft = localStorage.getItem(getDraftStorageKey());
            if (savedDraft) {
                showToast('info', translations.draftExists || 'A saved draft exists');
            }
            lastDraftContentRef.current = getCurrentFormContent();
        }
    }, [currentShop, isEditMode, employeeId]);

    useEffect(() => {
        if (isClearingRef.current) lastDraftContentRef.current = '';
    }, [formData.employee_name]);

    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
            isSubmittingRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (user?.language && user.language !== currentLanguage) {
            setCurrentLanguage(user.language);
        }
    }, [user?.language]);

    useEffect(() => {
        const loadTranslations = async () => {
            const trans = await employeeTranslator.getTranslations(currentLanguage);
            setTranslations(trans);
            // Update search terms with translations
            const selectedSalaryType = salaryTypeOptions.find(st => st.value === formData.salary_type);
            if (selectedSalaryType) {
                setSalaryTypeSearchTerm(trans[selectedSalaryType.label] || selectedSalaryType.label);
            }
            const selectedStatus = statusOptions.find(st => st.value === formData.status);
            if (selectedStatus) {
                setStatusSearchTerm(trans[selectedStatus.label] || selectedStatus.label);
            }
        };
        loadTranslations();
    }, [currentLanguage]);

    useEffect(() => {
        if (employeeId) {
            setIsEditMode(true);
            loadEmployeeData(employeeId);
        }
    }, [employeeId]);

    useEffect(() => {
        const loadAvailableShops = async () => {
            if (!user) return;
            setLoadingShops(true);
            try {
                const shopsData = await getShopsForSwitch();
                setAvailableShops(shopsData.shops || []);
            } catch (error) {
                console.error('Error loading shops:', error);
            } finally {
                setLoadingShops(false);
            }
        };
        loadAvailableShops();
    }, [user, getShopsForSwitch]);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.employee_name?.trim()) {
            newErrors.employee_name = translations.nameRequired || 'Employee name is required';
        }

        if (formData.phone && !/^[0-9+\-\s()]+$/.test(formData.phone)) {
            newErrors.phone = translations.phoneInvalid || 'Please enter a valid phone number';
        }

        if (formData.salary_type === 'fixed' && (!formData.fixed_salary || parseFloat(formData.fixed_salary) <= 0)) {
            newErrors.fixed_salary = translations.salaryRequired || 'Fixed salary amount is required';
        }

        if (formData.salary_type === 'daily' && (!formData.daily_wage_rate || parseFloat(formData.daily_wage_rate) <= 0)) {
            newErrors.daily_wage_rate = translations.salaryRequired || 'Daily wage rate is required';
        }

        if (formData.salary_type === 'task_based' && (!formData.task_rate || parseFloat(formData.task_rate) <= 0)) {
            newErrors.task_rate = translations.salaryRequired || 'Task rate is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!currentShop) {
            showToast('error', translations.selectShop || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }

        if (!validateForm()) return;

        if (isSubmittingRef.current) {
            showToast('warning', 'Please wait, submission in progress...');
            return;
        }

        const now = Date.now();
        if (now - lastSubmitTimeRef.current < 3000) {
            showToast('warning', 'Please wait before submitting again');
            return;
        }

        const currentEmployeeData = JSON.stringify({
            employee_name: formData.employee_name,
            phone: formData.phone,
            shop_id: currentShop.shop_id
        });

        if (!isEditMode && currentEmployeeData === lastEmployeeDataRef.current) {
            showToast('warning', 'This employee appears to be a duplicate. Please check.');
            return;
        }

        if (!isEditMode && isDuplicateRequest({
            action: 'add',
            employee_name: formData.employee_name,
            phone: formData.phone,
            shop_id: currentShop.shop_id
        })) {
            showToast('warning', 'Please wait, a similar employee is being added...');
            return;
        }

        lastEmployeeDataRef.current = currentEmployeeData;
        lastSubmitTimeRef.current = now;

        isSubmittingRef.current = true;
        setLoading(true);

        const submitButton = document.querySelector('button[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        try {
            const employeeData = {
                action: isEditMode ? 'edit' : 'add',
                ...formData,
                username: user?.username || 'Unknown',
                shop_id: currentShop.shop_id,
                _timestamp: Date.now()
            };

            if (isEditMode && employeeId) {
                employeeData.employee_id = employeeId;
            }

            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000);

            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_employees.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(employeeData),
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            const data = await response.json();

            if (data.status === 'duplicate' || data.duplicate_prevention) {
                showToast('warning', data.message || 'Duplicate submission prevented. Please wait.');
                lastEmployeeDataRef.current = '';
                return;
            }

            if (data.status === 'success') {
                showToast('success', isEditMode
                    ? (translations.employeeUpdated || 'Employee updated successfully!')
                    : (translations.employeeSaved || 'Employee saved successfully!'));

                const draftKey = getDraftStorageKey();
                localStorage.removeItem(draftKey);
                lastDraftContentRef.current = '';

                if (!isEditMode) {
                    setFormData(initialFormData);
                    setSalaryTypeSearchTerm('');
                    setStatusSearchTerm('');
                    setErrors({});
                    lastEmployeeDataRef.current = '';
                }

                if (onSuccess) onSuccess(data.employee_id || employeeId);
            } else {
                showToast('error', data.message || (isEditMode ? translations.failedUpdate : translations.failedAdd));
                lastEmployeeDataRef.current = '';
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                showToast('error', 'Request timeout. Please try again.');
            } else {
                console.error('Submit error:', error);
                showToast('error', error.message || translations.networkError || 'Network error');
            }
            lastEmployeeDataRef.current = '';
        } finally {
            setTimeout(() => {
                isSubmittingRef.current = false;
                setLoading(false);
                if (submitButton) submitButton.disabled = false;
            }, 3000);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleClear = () => {
        isClearingRef.current = true;
        const draftKey = getDraftStorageKey();
        localStorage.removeItem(draftKey);
        lastDraftContentRef.current = '';

        setFormData(initialFormData);
        setSalaryTypeSearchTerm('');
        setStatusSearchTerm('');
        setErrors({});
        setIsEditMode(false);
        lastEmployeeDataRef.current = '';

        showToast('success', translations.draftCleared || 'Form cleared');

        setTimeout(() => {
            isClearingRef.current = false;
        }, 500);
    };

    const handleSwitchShop = async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                const draftKey = getDraftStorageKey();
                localStorage.removeItem(draftKey);
                setFormData(initialFormData);
                setSalaryTypeSearchTerm('');
                setStatusSearchTerm('');
                setErrors({});
                setIsEditMode(false);
                lastDraftContentRef.current = '';
            }
            showToast(success ? 'success' : 'error',
                success ? (translations.shopSwitched || 'Shop switched successfully')
                    : (translations.shopSwitchFailed || 'Failed to switch shop'));
        } catch (error) {
            showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
        }
    };

    const handleAddPayment = async () => {
        if (!paymentData.amount || parseFloat(paymentData.amount) <= 0) {
            showToast('error', 'Please enter a valid amount');
            return;
        }

        setPaymentLoading(true);
        try {
            const paymentRequest = {
                action: 'add_payment',
                employee_id: employeeId,
                shop_id: currentShop?.shop_id,
                username: user?.username,
                ...paymentData,
                amount: parseFloat(paymentData.amount)
            };

            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_employees.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(paymentRequest)
            });

            const data = await response.json();

            if (data.status === 'success') {
                showToast('success', 'Payment added successfully');
                setShowPaymentModal(false);
                setPaymentData({
                    amount: '',
                    payment_date: new Date().toISOString().split('T')[0],
                    payment_type: 'salary',
                    payment_method: 'cash',
                    description: ''
                });
            } else {
                showToast('error', data.message || 'Failed to add payment');
            }
        } catch (error) {
            showToast('error', 'Network error');
        } finally {
            setPaymentLoading(false);
        }
    };

    const loadEmployeeData = async (id) => {
        if (!currentShop) return;

        setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_employees.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_record',
                    employee_id: id,
                    shop_id: currentShop.shop_id
                })
            });

            const data = await response.json();

            if (data.status === 'success' && data.data) {
                setFormData(prev => ({
                    ...prev,
                    ...data.data,
                    themeColor: prev.themeColor
                }));
                const selectedSalaryType = salaryTypeOptions.find(st => st.value === data.data.salary_type);
                setSalaryTypeSearchTerm(selectedSalaryType ? (translations[selectedSalaryType.label] || selectedSalaryType.label) : '');
                const selectedStatus = statusOptions.find(st => st.value === data.data.status);
                setStatusSearchTerm(selectedStatus ? (translations[selectedStatus.label] || selectedStatus.label) : '');
                lastDraftContentRef.current = getCurrentFormContent();
            } else {
                showToast('error', data.message || 'Failed to load employee data');
            }
        } catch (error) {
            showToast('error', translations.networkError || 'Network error');
        } finally {
            setLoading(false);
        }
    };

    // Select handlers for dropdowns
    const selectSalaryType = (salaryType) => {
        setFormData(prev => ({ ...prev, salary_type: salaryType.value }));
        setSalaryTypeSearchTerm(translations[salaryType.label] || salaryType.label);
        setShowSalaryTypeDropdown(false);
    };

    const selectStatus = (status) => {
        setFormData(prev => ({ ...prev, status: status.value }));
        setStatusSearchTerm(translations[status.label] || status.label);
        setShowStatusDropdown(false);
    };

    // Theme color auto-sync with gradient orbs
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#6366f1';
        }
        document.documentElement.style.setProperty('--ozui-primary', color);
        document.documentElement.style.setProperty('--ozui-primary-dark', color);
        document.documentElement.style.setProperty('--ozui-primary-light', color);

        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 99; g = 102; b = 241;
        }

        let style = document.getElementById('dynamic-orb-styles-employee');
        if (!style) {
            style = document.createElement('style');
            style.id = 'dynamic-orb-styles-employee';
            document.head.appendChild(style);
        }

        style.textContent = `
            .ozui-header-bg-animation .gradient-orb.orb-1 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-2 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-3 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-4 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-5 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
            }
        `;

        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentThemeColor) {
                applyTheme(storedTheme);
            }
        }, 500);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [applyTheme, currentThemeColor]);

    // Dark mode auto-sync
    useEffect(() => {
        const syncDarkMode = () => {
            const isDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDarkMode);

            const container = document.querySelector('.ozui-container');
            if (container) {
                if (isDarkMode) {
                    container.classList.add('ozui-dark');
                } else {
                    container.classList.remove('ozui-dark');
                }
            }

            if (isDarkMode) {
                document.body.classList.add('ozui-dark');
                document.documentElement.classList.add('ozui-dark');
            } else {
                document.body.classList.remove('ozui-dark');
                document.documentElement.classList.remove('ozui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);

                const container = document.querySelector('.ozui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozui-dark');
                    } else {
                        container.classList.remove('ozui-dark');
                    }
                }

                if (isDark) {
                    document.body.classList.add('ozui-dark');
                    document.documentElement.classList.add('ozui-dark');
                } else {
                    document.body.classList.remove('ozui-dark');
                    document.documentElement.classList.remove('ozui-dark');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // Language auto-sync
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await employeeTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // RTL direction sync
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozui-rtl');
                container.classList.remove('ozui-ltr');
            } else {
                container.classList.add('ozui-ltr');
                container.classList.remove('ozui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // Render shop indicator
    const renderShopIndicator = () => {
        if (!currentShop) {
            return (
                <div className="ozui-shop-indicator no-shop">
                    <div className="ozui-shop-badge">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span className="ozui-shop-warning">
                            {translations.noShopSelected || 'No shop selected'}
                        </span>
                    </div>
                    <button
                        className="ozui-header-shop-btn"
                        onClick={() => setShowShopSelector(true)}
                    >
                        <FontAwesomeIcon icon={faExchangeAlt} />
                        <span>{translations.switchShop || 'Switch Shop'}</span>
                    </button>
                </div>
            );
        }

        return (
            <div className="ozui-shop-indicator">
                {/* Shop indicator content - hidden as per original */}
            </div>
        );
    };

    return (
        <div className={`ozui-container ${isRTL ? 'ozui-rtl' : 'ozui-ltr'} ${darkMode ? 'ozui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <PaymentModal
                isOpen={showPaymentModal}
                onClose={() => setShowPaymentModal(false)}
                onSubmit={handleAddPayment}
                translations={translations}
                loading={paymentLoading}
                paymentData={paymentData}
                setPaymentData={setPaymentData}
            />

            {/* Modern Animated Sticky Header */}
            <div className="ozui-sticky-header">
                <div className="ozui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozui-header-content">
                    <div className="ozui-header-left">
                        <div className="ozui-header-title">
                            <h1>{isEditMode ? (translations.editEmployee || 'Edit Employee') : (translations.addEmployee || 'Add Employee')}</h1>
                            <p>{translations.fillDetails || 'Fill in the employee details below'}</p>
                        </div>
                    </div>

                    <div className="ozui-header-right">
                        {renderShopIndicator()}

                        <div className="ozui-header-actions">
                            <button 
                                className="ozui-action-btn clear-draft" 
                                onClick={handleClear}
                                disabled={loading}
                                title={translations.clearForm || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                                <span>{translations.clearButton || 'Clear'}</span>
                            </button>

                            <button 
                                className="ozui-action-btn save-draft" 
                                onClick={() => saveDraft()}
                                disabled={loading || isEditMode}
                                title={translations.saveDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faFileAlt} />
                                <span>{translations.saveDraft || 'Save Draft'}</span>
                            </button>

                            <div className="ozui-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button 
                                    className="ozui-action-btn drafts-btn" 
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>

                                {showDraftsList && (
                                    <div className="ozui-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => (
                                                    <div key={draft.id} className="draft-item">
                                                        <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                            <div className="draft-name">
                                                                {draft.employee_name || translations.unnamedEmployee || 'Unnamed Employee'}
                                                            </div>
                                                            <div className="draft-details">
                                                                {draft.phone && <span>{draft.phone}</span>}
                                                                {draft.position && <span>{draft.position}</span>}
                                                            </div>
                                                            <div className="draft-date">
                                                                {new Date(draft.savedAt).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                        <button 
                                                            className="delete-draft-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteDraft(draft.id);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="ozui-form">
                <div className="ozui-form-row">
                    {/* Employee Name */}
                    <div className={`ozui-field ${errors.employee_name ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                ref={employeeNameInputRef}
                                type="text"
                                name="employee_name"
                                id="employee_name"
                                value={formData.employee_name}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                                autoFocus
                            />
                            <label htmlFor="employee_name">
                                <FontAwesomeIcon icon={faUser} />
                                {translations.employeeName || 'Employee Name'} <span>*</span>
                            </label>
                        </div>
                        {errors.employee_name && <small>{errors.employee_name}</small>}
                    </div>

                    {/* Employee Code */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="employee_code"
                                id="employee_code"
                                value={formData.employee_code}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="employee_code">
                                <FontAwesomeIcon icon={faIdCard} />
                                {translations.employeeCode || 'Employee Code'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                    </div>

                    {/* CNIC Number */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="cnic_number"
                                id="cnic_number"
                                value={formData.cnic_number}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="cnic_number">
                                <FontAwesomeIcon icon={faCnic} />
                                {translations.cnicNumber || 'CNIC Number'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                    </div>

                    {/* Phone */}
                    <div className={`ozui-field ${errors.phone ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="tel"
                                name="phone"
                                id="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="phone">
                                <FontAwesomeIcon icon={faPhone} />
                                {translations.phone || 'Phone Number'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                        {errors.phone && <small>{errors.phone}</small>}
                    </div>

                    {/* Position */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="position"
                                id="position"
                                value={formData.position}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="position">
                                <FontAwesomeIcon icon={faBriefcase} />
                                {translations.position || 'Position'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                    </div>

                    {/* Hire Date */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="date"
                                name="hire_date"
                                id="hire_date"
                                value={formData.hire_date}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="hire_date">
                                <FontAwesomeIcon icon={faCalendarAlt} />
                                {translations.hireDate || 'Hire Date'}
                            </label>
                        </div>
                    </div>

                    {/* Salary Type - Manual Dropdown */}
                    <div className={`ozui-field ${errors.salary_type ? 'ozui-error' : ''}`} ref={salaryTypeDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="salary_type"
                                value={salaryTypeSearchTerm}
                                onChange={(e) => {
                                    setSalaryTypeSearchTerm(e.target.value);
                                    setShowSalaryTypeDropdown(true);
                                    if (formData.salary_type && !salaryTypeOptions.find(st => 
                                        (translations[st.label] || st.label).toLowerCase() === e.target.value.toLowerCase()
                                    )) {
                                        setFormData(prev => ({ ...prev, salary_type: '' }));
                                    }
                                }}
                                onFocus={() => setShowSalaryTypeDropdown(true)}
                                onKeyDown={handleSalaryTypeKeyDown}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="salary_type">
                                <FontAwesomeIcon icon={faMoneyBillWave} />
                                {translations.salaryType || 'Salary Type'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {showSalaryTypeDropdown && (
                            <div className="ozui-category-dropdown">
                                {filteredSalaryTypes.length > 0 ? (
                                    filteredSalaryTypes.map(st => (
                                        <div
                                            key={st.value}
                                            className={`ozui-category-option ${formData.salary_type === st.value ? 'ozui-selected' : ''}`}
                                            onClick={() => selectSalaryType(st)}
                                        >
                                            {translations[st.label] || st.label}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No salary types found</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Fixed Salary Amount */}
                    {formData.salary_type === 'fixed' && (
                        <div className={`ozui-field ${errors.fixed_salary ? 'ozui-error' : ''}`}>
                            <div className="ozui-input-wrapper">
                                <input
                                    type="number"
                                    name="fixed_salary"
                                    id="fixed_salary"
                                    value={formData.fixed_salary}
                                    onChange={handleChange}
                                    step="0.01"
                                    min="0"
                                    placeholder=" "
                                    disabled={loading}
                                />
                                <label htmlFor="fixed_salary">
                                    <FontAwesomeIcon icon={faMoneyBillWave} />
                                    {translations.fixedSalaryAmount || 'Fixed Salary Amount'}
                                </label>
                            </div>
                            {errors.fixed_salary && <small>{errors.fixed_salary}</small>}
                        </div>
                    )}

                    {/* Daily Wage Rate */}
                    {formData.salary_type === 'daily' && (
                        <div className={`ozui-field ${errors.daily_wage_rate ? 'ozui-error' : ''}`}>
                            <div className="ozui-input-wrapper">
                                <input
                                    type="number"
                                    name="daily_wage_rate"
                                    id="daily_wage_rate"
                                    value={formData.daily_wage_rate}
                                    onChange={handleChange}
                                    step="0.01"
                                    min="0"
                                    placeholder=" "
                                    disabled={loading}
                                />
                                <label htmlFor="daily_wage_rate">
                                    <FontAwesomeIcon icon={faClock} />
                                    {translations.dailyWageRate || 'Daily Wage Rate'}
                                </label>
                            </div>
                            {errors.daily_wage_rate && <small>{errors.daily_wage_rate}</small>}
                        </div>
                    )}

                    {/* Task Rate */}
                    {formData.salary_type === 'task_based' && (
                        <div className={`ozui-field ${errors.task_rate ? 'ozui-error' : ''}`}>
                            <div className="ozui-input-wrapper">
                                <input
                                    type="number"
                                    name="task_rate"
                                    id="task_rate"
                                    value={formData.task_rate}
                                    onChange={handleChange}
                                    step="0.01"
                                    min="0"
                                    placeholder=" "
                                    disabled={loading}
                                />
                                <label htmlFor="task_rate">
                                    <FontAwesomeIcon icon={faTasks} />
                                    {translations.taskRate || 'Task Rate'}
                                </label>
                            </div>
                            {errors.task_rate && <small>{errors.task_rate}</small>}
                        </div>
                    )}

                    {/* Status - Manual Dropdown */}
                    <div className="ozui-field" ref={statusDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="status"
                                value={statusSearchTerm}
                                onChange={(e) => {
                                    setStatusSearchTerm(e.target.value);
                                    setShowStatusDropdown(true);
                                    if (formData.status && !statusOptions.find(st => 
                                        (translations[st.label] || st.label).toLowerCase() === e.target.value.toLowerCase()
                                    )) {
                                        setFormData(prev => ({ ...prev, status: '' }));
                                    }
                                }}
                                onFocus={() => setShowStatusDropdown(true)}
                                onKeyDown={handleStatusKeyDown}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="status">
                                <FontAwesomeIcon icon={faUserTag} />
                                {translations.status || 'Status'}
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {showStatusDropdown && (
                            <div className="ozui-category-dropdown">
                                {filteredStatuses.length > 0 ? (
                                    filteredStatuses.map(st => (
                                        <div
                                            key={st.value}
                                            className={`ozui-category-option ${formData.status === st.value ? 'ozui-selected' : ''}`}
                                            onClick={() => selectStatus(st)}
                                        >
                                            {translations[st.label] || st.label}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No statuses found</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Address */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="address"
                                id="address"
                                value={formData.address}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="address">
                                <FontAwesomeIcon icon={faMapMarkerAlt} />
                                {translations.address || 'Address'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                    </div>
                </div>

                {/* Form Actions */}
                <div className="ozui-form-actions">
                    {isEditMode && (
                        <button 
                            type="button" 
                            className="ozui-btn ozui-btn-info" 
                            onClick={() => setShowPaymentModal(true)} 
                            disabled={loading}
                        >
                            <FontAwesomeIcon icon={faMoneyBillWave} />
                            <span>{translations.addPayment || 'Add Payment'}</span>
                        </button>
                    )}
                   
                    <button 
                        type="submit" 
                        className="ozui-btn ozui-btn-primary" 
                        disabled={loading || !currentShop || isSubmittingRef.current}
                    >
                        {loading ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                <span>{isEditMode ? (translations.updating || 'Updating...') : (translations.adding || 'Adding...')}</span>
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faSave} />
                                <span>{isEditMode ? (translations.update || 'Update') : (translations.save || 'Save')}</span>
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PharmacyAddEmployee;